export const sky = {
  1: { value: { base: '{colors.sky.light.1}', _dark: '{colors.sky.dark.1}' } },
  2: { value: { base: '{colors.sky.light.2}', _dark: '{colors.sky.dark.2}' } },
  3: { value: { base: '{colors.sky.light.3}', _dark: '{colors.sky.dark.3}' } },
  4: { value: { base: '{colors.sky.light.4}', _dark: '{colors.sky.dark.4}' } },
  5: { value: { base: '{colors.sky.light.5}', _dark: '{colors.sky.dark.5}' } },
  6: { value: { base: '{colors.sky.light.6}', _dark: '{colors.sky.dark.6}' } },
  7: { value: { base: '{colors.sky.light.7}', _dark: '{colors.sky.dark.7}' } },
  8: { value: { base: '{colors.sky.light.8}', _dark: '{colors.sky.dark.8}' } },
  9: { value: { base: '{colors.sky.light.9}', _dark: '{colors.sky.dark.9}' } },
  10: { value: { base: '{colors.sky.light.10}', _dark: '{colors.sky.dark.10}' } },
  11: { value: { base: '{colors.sky.light.11}', _dark: '{colors.sky.dark.11}' } },
  12: { value: { base: '{colors.sky.light.12}', _dark: '{colors.sky.dark.12}' } },
  a1: { value: { base: '{colors.sky.light.a1}', _dark: '{colors.sky.dark.a1}' } },
  a2: { value: { base: '{colors.sky.light.a2}', _dark: '{colors.sky.dark.a2}' } },
  a3: { value: { base: '{colors.sky.light.a3}', _dark: '{colors.sky.dark.a3}' } },
  a4: { value: { base: '{colors.sky.light.a4}', _dark: '{colors.sky.dark.a4}' } },
  a5: { value: { base: '{colors.sky.light.a5}', _dark: '{colors.sky.dark.a5}' } },
  a6: { value: { base: '{colors.sky.light.a6}', _dark: '{colors.sky.dark.a6}' } },
  a7: { value: { base: '{colors.sky.light.a7}', _dark: '{colors.sky.dark.a7}' } },
  a8: { value: { base: '{colors.sky.light.a8}', _dark: '{colors.sky.dark.a8}' } },
  a9: { value: { base: '{colors.sky.light.a9}', _dark: '{colors.sky.dark.a9}' } },
  a10: { value: { base: '{colors.sky.light.a10}', _dark: '{colors.sky.dark.a10}' } },
  a11: { value: { base: '{colors.sky.light.a11}', _dark: '{colors.sky.dark.a11}' } },
  a12: { value: { base: '{colors.sky.light.a12}', _dark: '{colors.sky.dark.a12}' } },
}
